import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class FloorNameMinimumCharacterError extends CodedError {
  static get errorName() {
    return errorCodeTypes.floorNameMinimumCharacterError.code;
  }

  constructor(message = errorCodeTypes.floorNameMinimumCharacterError.message) {
    super(message);
    this.code = errorCodeTypes.floorNameMinimumCharacterError.code;
    this.message = `${message} ${errorCodeTypes.floorNameMinimumCharacterError.code}`;
    this.name = errorCodeTypes.floorNameMinimumCharacterError.name;
  }
}
